/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import BaseMedicalHistoryFormComponent from "parog-web/components/medical-history/abstract/base-edition-form";
import MedicalHistoryBaseEditionForm from "../base-edition-form";

export default class MedicalHistoryFormComponent extends BaseMedicalHistoryFormComponent {
  MedicalHistoryBaseEditionForm = MedicalHistoryBaseEditionForm;

  journalEventProperties = [
    ...this.sharedProperties,
    ...this.hepaticPathologyProperties
  ];

  get validations(): Record<string, unknown> {
    return {};
  }

  get hepaticPathologyProperties(): string[] {
    return [
      "transplantDate",
      "transplantRank",
      "transplantedOrgan",
      "underlyingDisease",
      "cytomegalovirusStatus"
    ];
  }

  retrieveModel(): Record<string, unknown> {
    const model = super.retrieveModel();
    if (!this.isLoadedFromJe) {
      model.transplantedOrgan = "liver";
    }

    return model;
  }
}
